import { PAGE_TYPE_ACTIVITY } from 'constants/index';
import { useCountries } from 'hooks/useCountries';
import useValidationSchema from 'hooks/useValidationSchema';

import { useAreasRequest } from '../../shared/hooks/useAreasRequest';
import validationSchema from './validationSchema';

export function useActivityDetails({ page }) {
  const { areas, areasBeingLoaded, onCountryChange } = useAreasRequest({
    targetId: page.activityId,
    pageType: PAGE_TYPE_ACTIVITY,
    countryId: page.countryId,
  });

  const validate = useValidationSchema(validationSchema);
  const countries = useCountries();

  return {
    areas,
    areasBeingLoaded,
    onCountryChange,
    validate,
    countries,
  };
}
